import Vue from 'vue';
import { resetAllLoginData } from '../../lib/Authentication/src/VerifyTokenJWT';

// Estado inicial
const initialState = () => ({
  user: null,
  token: null,
  baseUrl: null,
});

// Objeto de estado
const state = initialState();

// Getters
const getters = {
  isAuthenticated: (state) => !!state.user,
  getUser: (state) => state.user,
  getToken: (state) => state.token,
  getBaseUrl: (state) => state.baseUrl,
  getUserPermissions: (state) => state.user?.permissoes || {},
  hasPermission: (state) => (resource, permission) => {
    if (!state.user?.permissoes) return false;
    const userPerm = state.user.permissoes[resource];
    if (!userPerm) return false;
    return userPerm === permission || userPerm === 'w' || (permission === 'r' && userPerm === 'r');
  },
};

// Ações
const actions = {
  clearState({ commit }) {
    commit('RESET');
  },
  setAuthentication({ commit }, { token, baseUrl }) {
    // Se já existe uma instância do HttpClient, apenas atualizar o token
    if (Vue.prototype.$httpClient && Vue.prototype.$httpClient.token !== undefined) {
      Vue.prototype.$httpClient.token = token;
    } else {
      // Criar nova instância do HttpClient
      new Vue.prototype.$httpClient(baseUrl, token);
    }

    commit('SET_TOKEN', token);
    commit('SET_BASE_URL', baseUrl);
  },
  setUser({ commit }, user) {
    commit('SET_USER', user);
    // Persistir no localStorage
    if (user) {
      localStorage.setItem('userData', JSON.stringify(user));
    } else {
      localStorage.removeItem('userData');
    }
  },
  logout({ commit }) {
    commit('RESET');
    resetAllLoginData();
  },
  // Recuperar dados do usuário do localStorage
  initializeUserData({ commit }) {
    const userData = localStorage.getItem('userData');
    if (userData) {
      try {
        const user = JSON.parse(userData);
        commit('SET_USER', user);
      } catch (error) {
        console.error('Error parsing user data from localStorage:', error);
      }
    }
  },

  initPolgoApiLoginSSOSession({ commit }, { ambiente, cliente }) {
    return new Promise(async (resolve) => {
      const api = new Vue.prototype.$httpClient();
      const url = `/api/sso/iniciar-sessao-polgo`;
      const response = await api.send(
        url,
        'POST',
        {
          ambiente,
          cliente,
        },
        undefined,
        false
      );

      if (response.status === 200 || response.status === 201) {
        resolve({
          status: response.status,
          msg: response.data.mensagem,
          tokenJWT: response.data.dados.tokenJWT,
        });
      } else {
        resolve({
          status: response.status,
          msg: response.data.mensagem || 'Ocorreu um erro desconhecido durante sua requisição.',
        });
      }
    });
  },
};

// Mutações
const mutations = {
  RESET(state) {
    const newState = initialState();
    Object.keys(newState).forEach((key) => {
      state[key] = newState[key];
    });
  },
  SET_USER(state, user) {
    state.user = user;
  },
  SET_TOKEN(state, token) {
    state.token = token;
  },
  SET_BASE_URL(state, baseUrl) {
    state.baseUrl = baseUrl;
  },
};

// Exoprtando módulo
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
